import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MsalBroadcastService } from "@azure/msal-angular";
import { InteractionStatus } from "@azure/msal-browser";
import { BaseComponent } from "@hub/common/BaseComponent";
import { AuthService } from "@hub/services/AuthService";
import { PageLoaderService } from "@hub/services/PageLoader";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";


@Component({
  selector: "login",
  templateUrl: "./login.component.html",
})
export class LoginComponent extends BaseComponent implements OnInit, OnDestroy {
  private readonly destroying$ = new Subject<void>();

  // Constructors
  constructor(
    private router: Router,
    private authService: AuthService,
    private pageLoaderService: PageLoaderService,
    private msalBroadcastService: MsalBroadcastService
  ) {
    super();
  }

  ngOnInit(): void {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this.destroying$)
      )
      .subscribe(() => {
        if (this.authService.isLogged) {
          this.navigateToRedirectUrl();
          return;
        }

        this.login();
      });
  }

  ngOnDestroy(): void {
    this.destroying$.next();
    this.destroying$.complete();
  }

  private navigateToRedirectUrl(): void {
    const url = this.authService.redirectUrl;
    this.authService.redirectUrl = "";

    if (!url || url.includes("/login")) {
      this.router.navigate([""]);
    } else {
      this.router.navigate([url]);
    }
  }

  // Public Methods
  public login(): void {
    if (this.authService.isLogged || this.authService.isInteractionInProgress) {
      this.pageLoaderService.hidePageLoader();
      return;
    }

    this.pageLoaderService.showPageLoader();
    this.authService.login();
  }
}
